import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { exchangeSession } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        // Strip fragment from URL and go to admin
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user } });
      } catch (err) {
        navigate("/admin/login", { replace: true, state: { error: "Sign-in failed. Please try again." } });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div
      data-testid="auth-callback-loading"
      className="min-h-[60vh] flex items-center justify-center"
    >
      <div className="text-center">
        <div className="text-xs uppercase tracking-[0.22em] text-ember font-accent font-semibold">
          One moment
        </div>
        <p className="mt-4 font-serif text-2xl text-ink">Signing you in…</p>
      </div>
    </div>
  );
}
